import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Layout from "./Components/Layout";
import Login from "./Components/Login";
import Signup from "./Components/Signup";
import Dashboard from "./Components/Profile";
import ChitChat from "./Components/ChitChat";
import Post from "./Components/Post";
import Calendar from "./Components/Calender";
import Notes from "./Components/Notes";
import NewDoc from "./Components/NewDoc";
import Books from "./Components/Books";
import AssignmentInfo from "./Components/AssignmentInfo";
import AssignmentDetails from "./Components/AssignmentDetails";
import ELearning from "./Components/eLearning";
import EvaluatedAssignment from "./Components/EvaluatedAssignment";
import ExamInfo from './Components/ExamInfo';
import ExamPortal from './Components/ExamPortal';
import ExamDetails from './Components/ExamDetails';
import ELearningCourseStart from './Components/eLearningCourseStart';
import ResetPassword from './Components/ResetPassword';
import CourseDetails from './Components/eLearningCourseDetails';
import LandingPage from './Components/LandingPage';
import SubmittedAssignmentDetails from './Components/SubmiitedAssignmentDetial'
import ExamInstructionsPage from './Components/ExamInstruction';
import SubmittedExamDetails from './Components/SubmittedExamDetials';
import StudyBuddy from './Components/StudyBuddy';
import NewLandingPage from './Components/NewLandingPage';
import QuizInfo from './Components/QuizInfo';
import QuizDetails from './Components/QuizDetials';
import SubmittedQuizDetails from './Components/SubmittedQuizDetials';
import StudentPerformance from './Components/StudentPerformance'
import EditStudentProfile from './Components/EditStudentPage';
import ViewCoursesELearning from './Components/viewcourseselearning';
import StudentDashboard from './Components/Dashboard';


export default function App() {
  return (
    <Provider store={store}>
    <BrowserRouter>
      <Routes>  
        <Route path='/reset-password' element={<ResetPassword/>}/>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/logout" element={<NewLandingPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/" element={<Layout />}>
          <Route path="Profile" element={<Dashboard/>}/>
          <Route path="Dashboard" element={<StudentDashboard/>}/>
          <Route path="Communication" element={<ChitChat/>}/>
          <Route path="post" element={<Post/>}/>
          <Route path="calendar" element={<Calendar/>}/>
          <Route path="notes" element={<Notes/>}/>
          <Route path="new-doc" element={<NewDoc/>}/>
          <Route path="library" element={<Books/>}/>
          <Route path="assignments" element={<AssignmentInfo/>}/>
          <Route path="assignment/details/:id" element={<AssignmentDetails/>}/>
          <Route path="assignments/results/:id" element={<EvaluatedAssignment />} />
          <Route path="elearning" element={<ELearning/>}/>
          <Route path="exams" element={<ExamInfo/>}/>
          <Route path="/exam/details/:id/instruction" element={<ExamInstructionsPage/>}/>
          <Route path="/exam/details/:id" element={<ExamDetails/>}/>
          <Route path="/eLearning/course/:courseId" element={<ELearningCourseStart />} />
          <Route path="eLearning/course/enroll/:courseId" element={<CourseDetails />} />
          <Route path="eLearning/view/:courseId" element={<ViewCoursesELearning />} />
          <Route path="/submitted-assignment/:id" element={<SubmittedAssignmentDetails />} />
          <Route path="/exam/submitted-exam/:id" element={<SubmittedExamDetails />} />
          <Route path="/books/studybuddy/:bookId" element={<StudyBuddy/>} />
          <Route path="/quiz" element={<QuizInfo/>} />
          <Route path="/quiz/results/:id" element={<SubmittedQuizDetails/>} />
          <Route path="/student/details" element={<StudentPerformance/>} />
          <Route path="/student/profile-edit" element={<EditStudentProfile/>} />
         
          
        </Route>
        <Route path="/quiz/take/:id" element={<QuizDetails/>} />
        <Route path="/exam/start/:id" element={<ExamPortal/>}/>
      </Routes>
    </BrowserRouter>
    </Provider>
  );
}